import { Controller } from 'stimulus'

/**
 * Manages GTM datalayer tracking for the portal-update page (StimulusJS controller)
 *
 * @class PortalUpdateController
 * @memberof Controllers
 */
export default class extends Controller {
  /**
   * @function Controllers.PortalUpdateController.trackCta
   * @memberof Controllers
   * @description Pushes a cta_click event to the GTM dataLayer on CTA button click
   *
   * @param {Event} event - Click event
   */
  trackCta(event) {
    const el         = event.currentTarget
    const ctaName    = el.dataset.ctaName
    const isExternal = el.dataset.external === 'true'

    // Prevent navigation for external links so GTM has time to fire all tags
    // before the page unloads. eventCallback resumes navigation once GTM is done,
    // and eventTimeout ensures navigation always happens even if GTM is slow.
    if (isExternal) { event.preventDefault() }

    const payload = {
      'event':        'cta_click',
      'cta_name':     ctaName,
      'cta_location': 'hero',
      'session_uuid': sessionStorage.getItem('sessionUUID')
    }

    if (isExternal) {
      const href = el.href
      payload['eventCallback'] = () => { window.location = href }
      payload['eventTimeout']  = 2000
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  }
}
